import { TYPES } from "./client.type";

const initState = {
  client: null,
};

const clientReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_CLIENT_SUCCESS:
      return {
        ...state,
        client: payload,
      };

    default:
      return state;
  }
};

export default clientReducer;
